module.exports = __webpack_public_path__ + "static/media/test10_2.27d6c576.png";